import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React from 'react';

interface DeletePetDialogProps {
  open: boolean;
  petName: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

const DeletePetDialog: React.FC<DeletePetDialogProps> = (props: DeletePetDialogProps) => {
  const { open, petName, onClose, onConfirm, isDeleting } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxWidth: 420,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>Delete {petName}?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          This will remove {petName} from your profile. Past bookings will not be affected.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderColor: '#E0E0E0',
            color: 'text.primary',
            '&:hover': {
              borderColor: '#BDBDBD',
              backgroundColor: '#F5F5F5',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            backgroundColor: '#D32F2F',
            '&:hover': {
              backgroundColor: '#B71C1C',
            },
          }}
          disabled={isDeleting}
        >
          Delete Pet
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePetDialog;
